<form [formGroup]="accountForm" (ngSubmit)="updateEmail()" class="account-section">
  <div class="form-group">
    <label for="email"></label>
    <input id="email" type="email" formControlName="email" placeholder="Nouvel email" [ngClass]="{ 'is-invalid': submittedEmail && email.invalid }" />

    @if (submittedEmail && email.errors) {
      <div class="error-msg">
        @if (email.errors['required']) {
          <span>Email requis</span>
        }
        @if (email.errors['pattern']) {
          <span>Format d'email invalide</span>
        }
      </div>
    }
  </div>

  <button type="submit" class="button-component">Mettre à jour l'email</button>
</form>

<hr />

<form [formGroup]="passwordForm" (ngSubmit)="updatePassword()" class="account-section">
  <div class="form-group">
    <label for="password"></label>
    <input
      id="password"
      type="password"
      formControlName="password"
      placeholder="Nouveau Mot de passe"
      [ngClass]="{ 'is-invalid': submittedPassword && password.invalid }" />

    @if (submittedPassword && password.errors) {
      <div class="error-msg">
        @if (password.errors['required']) {
          <span>Mot de passe requis</span>
        }
        @if (password.errors['minlength']) {
          <span>Le mot de passe doit contenir au moins {{ password.errors['minlength'].requiredLength }} caractères.</span>
        }
        @if (password.errors['pattern']) {
          <span>Le mot de passe doit contenir au moins une majuscule, une minuscule, un chiffre et un caractère spécial.</span>
        }
      </div>
    }
  </div>

  <div class="form-group">
    <label for="confirmPassword"></label>
    <input
      id="confirmPassword"
      type="password"
      formControlName="confirmPassword"
      placeholder="Confirmer votre Mot de passe"
      [ngClass]="{ 'is-invalid': submittedPassword && confirmPassword.invalid }" />

    @if (submittedPassword && confirmPassword.errors) {
      <div class="error-msg">
        @if (confirmPassword.errors['required']) {
          <span>Confirmation requise</span>
        }
        @if (passwordMismatch) {
          <span>Les mots de passe ne correspondent pas</span>
        }
      </div>
    }
  </div>

  <button type="submit" class="button-component">Mettre à jour le mot de passe</button>
</form>

<hr />

<div class="delete-section">
  <button type="button" (click)="deleteAccount()" class="button-component warning">Supprimer le compte</button>
</div>
